import moment from "moment";
import Checkbox from "../../framework/Checkbox";
import { PRODUCTS_TAB } from "../../framework/tab/tabUtilsConstants";
import {
  medicineCategories,
  medicineScheduleTypes,
} from "../../utils/constant";

export const columnDefs = [
  {
    headerName: "checked",
    field: "checked",
    width: 50,
    floatingFilter: false,
  },
  {
    headerName: "Product Id",
    field: "medicineId",
    hide: true,
  },
  {
    headerName: "Product",
    field: "medicineNameDetailed",
    width: 380,
  },
  {
    headerName: "Short Code",
    field: "medicineShortCode",
    width: 100,
  },
  {
    headerName: "Packaging",
    field: "medicinePackaging",
    width: 120,
  },
  {
    headerName: "Outer Packaging",
    field: "outerQtyPack",
    width: 120,
    hide: true,
  },
  {
    headerName: "Product Brand",
    field: "medicineNameBase",
    width: 120,
  },
  {
    headerName: "Item Type",
    field: "itemtype",
    width: 120,
  },
  {
    headerName: "Is Recipe",
    field: "isRecipe",
    width: 100,
    hide: false,
  },
  {
    headerName: "Scheduled Type",
    field: "scheduledId",
    width: 130,
  },
  {
    headerName: "Manufacturer",
    field: "manufacturerName",
    width: 300,
  },
  {
    headerName: "Manufacturer Group",
    field: "manufacturerGroupName",
    width: 300,
  },
  {
    headerName: "Marketer",
    field: "marketerName",
    width: 120,
    hide: true,
  },
  {
    headerName: "Category",
    field: "category",
    width: 100,
  },
  {
    headerName: "GST%",
    field: "medicineGstPer",
    width: 100,
  },
  {
    headerName: "DP%",
    field: "dpPercentage",
    width: 100,
  },
  {
    headerName: "Gccess",
    field: "gccess",
    width: 100,
  },
  {
    headerName: "Tcs Per",
    field: "tcsPer",
    width: 100,
  },
  {
    headerName: "B2B Markup %",
    field: "b2BOffset",
    width: 100,
  },
  {
    headerName: "B2B Selling Price ₹",
    field: "b2bSellingPrice",
    width: 180,
  },
  {
    headerName: "B2B Force Selling Price",
    field: "b2bForceSellingPrice",
    width: 180,
  },
  {
    headerName: "DP %",
    field: "dpPercentage",
    width: 100,
    hide: true,
  },
  {
    headerName: "Vat",
    field: "vat",
    width: 100,
    hide: true,
  },
  {
    headerName: "Lock PO/Purchase",
    field: "isBanned",
    width: 120,
  },
  {
    headerName: "Lock",
    field: "isDiscontinued",
    width: 100,
  },
  {
    headerName: "Is Chronic",
    field: "isChronic",
    width: 100,
  },
  {
    headerName: "Is Undeliverable",
    field: "isUndeliverable",
    width: 100,
  },
  {
    headerName: "Allow Web",
    field: "allowWeb",
    width: 100,
  },
  {
    headerName: "Barcode",
    field: "barcode",
    width: 100,
  },
  {
    headerName: "Divisor",
    field: "divisor",
    width: 100,
  },
  {
    headerName: "Max Stock",
    field: "maxStock",
    width: 100,
  },
  {
    headerName: "Min Stock",
    field: "minStock",
    width: 100,
  },
  {
    headerName: "Max Days",
    field: "maxDays",
    width: 100,
    hide: true,
  },
  {
    headerName: "Min Days",
    field: "minDays",
    width: 100,
    hide: true,
  },
  {
    headerName: "Auto Order Days",
    field: "autoOrderDays",
    width: 100,
    hide: true,
  },
  {
    headerName: "Rack 1",
    field: "rack",
    width: 100,
  },
  {
    headerName: "Rack 2",
    field: "rack1",
    width: 100,
  },
  {
    headerName: "Hsn Code",
    field: "hsnCode",
    width: 100,
  },
  {
    headerName: "Allow Discount",
    field: "allowDiscount",
    width: 100,
  },
  {
    headerName: "Discount %",
    field: "discPer",
    width: 100,
  },
  {
    headerName: "Max Discount %",
    field: "maxDiscount",
    width: 100,
  },
  {
    headerName: "Is Loose",
    field: "isLoose",
    width: 100,
  },
  {
    headerName: "Is Returnable",
    field: "isReturnable",
    width: 100,
  },
  {
    headerName: "Rate Itemwise",
    field: "rateItemwise",
    width: 100,
  },
  {
    headerName: "Block Expiry Print",
    field: "blockExpiryPrint",
    width: 100,
  },
  {
    headerName: "Skip From Apo",
    field: "skipFromApo",
    width: 100,
  },
  {
    headerName: "Skip From Short Book",
    field: "skipFromShortBook",
    width: 100,
  },
  {
    headerName: "Compute Min-Max",
    field: "computeMinMax",
    width: 100,
    hide: true,
  },
  {
    headerName: "Disable Auto Barcode",
    field: "disableAutoBarcodePrinting",
    width: 100,
    hide: true,
  },
  {
    headerName: "Selling Price",
    field: "sellingPrice",
    width: 100,
  },
  {
    headerName: "Cost Price",
    field: "passiveCp",
    width: 100,
  },
  {
    headerName: "Mrp",
    field: "passiveMrp",
    width: 100,
  },
  {
    headerName: "Markup Price",
    field: "markup",
    width: 100,
    hide: true,
  },
  {
    headerName: "Box Mrp",
    field: "boxMrp",
    width: 100,
    hide: true,
  },
  {
    headerName: "Box Ptr",
    field: "boxPtr",
    width: 100,
    hide: true,
  },
  {
    headerName: "Storage",
    field: "storage",
    width: 100,
  },
  {
    headerName: "Therapeutic",
    field: "therapeutic",
    width: 130,
  },
  {
    headerName: "Sub-Therapeutic",
    field: "subtherapeutic",
    width: 130,
    hide: true,
  },
  {
    headerName: "Salts",
    field: "genericDosage",
    width: 100,
    hide: true,
  },
  {
    headerName: "Content",
    field: "description",
    width: 150,
    hide: true,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    width: 100,
  },
];

export const columnDefsFunctions = {
  checked: {
    cellRendererFramework: (params) => {
      return (
        <Checkbox
          checked={params.data.checked}
          onChange={(event) => {
            params.data.checked = event.target.checked;
            params.api.redrawRows({
              rowNodes: [params.api.getRowNode(params.node.rowIndex)],
            });
          }}
        />
      );
    },
    headerComponentFramework: (params) => {
      let allRowsChecked = false;
      let count = 0;
      params.api.forEachNode((node) => {
        if (node.data.checked) count++;
        if (count === params.api.getDisplayedRowCount()) {
          allRowsChecked = true;
        } else {
          allRowsChecked = false;
        }
      });
      return (
        <Checkbox
          checked={allRowsChecked}
          onChange={(event) => {
            params.api.forEachNode((node) => {
              node.data.checked = event.target.checked;
              params.api.redrawRows({
                rowNodes: [params.api.getRowNode(node.rowIndex)],
              });
            });
            allRowsChecked = event.target.checked;
          }}
        />
      );
    },
  },
  allowDiscount: {
    valueGetter: (params) => {
      return params.data.allowDiscount ? "true" : "false";
    },
  },
  isReturnable: {
    valueGetter: (params) => {
      return params.data.isReturnable ? "true" : "false";
    },
  },
  isLoose: {
    valueGetter: (params) => {
      return params.data.isLoose ? "true" : "false";
    },
  },
  rateItemwise: {
    valueGetter: (params) => {
      return params.data.rateItemwise ? "true" : "false";
    },
  },
  manufacturerGroupName: {
    valueGetter: (params) => {
      return params.data?.manufacturerGroup?.name || "";
    },
  },
  scheduledId: {
    valueGetter: (params) => {
      return medicineScheduleTypes.filter(
        (scheduleType) => scheduleType.id === params.data.scheduledId
      )[0]?.label;
    },
  },
  categoryId: {
    valueGetter: (params) => {
      return medicineCategories.filter(
        (g) => g.id === params.data.categoryId
      )[0]?.label;
    },
  },
  category: {
    valueGetter: (params) => params.data.category?.categoryName,
  },
  skipFromApo: {
    valueGetter: (params) => {
      return params.data.skipFromApo ? "true" : "false";
    },
  },
  skipFromShortBook: {
    valueGetter: (params) => {
      return params.data.skipFromShortBook ? "true" : "false";
    },
  },
  isChronic: {
    valueGetter: (params) => {
      return params.data.isChronic ? "true" : "false";
    },
  },
  isTb: {
    valueGetter: (params) => {
      return params.data.isTb ? "true" : "false";
    },
  },
  isBanned: {
    valueGetter: (params) => {
      return params.data.isBanned ? "true" : "false";
    },
  },
  b2bForceSellingPrice: {
    valueGetter: (params) => {
      return params.data.b2bForceSellingPrice ? "true" : "false";
    },
  },
  isDiscontinued: {
    valueGetter: (params) => {
      return params.data.isDiscontinued ? "true" : "false";
    },
  },
  isUndeliverable: {
    valueGetter: (params) => {
      return params.data.isUndeliverable ? "true" : "false";
    },
  },
  allowWeb: {
    valueGetter: (params) => {
      return params.data.allowWeb ? "true" : "false";
    },
  },
  isActive: {
    valueGetter: (params) => {
      return params.data.isActive ? "true" : "false";
    },
  },
  computeMinMax: {
    valueGetter: (params) => {
      return params.data.computeMinMax ? "true" : "false";
    },
  },
  disableAutoBarcodePrinting: {
    valueGetter: (params) => {
      return params.data.disableAutoBarcodePrinting ? "true" : "false";
    },
  },
  blockExpiryPrint: {
    valueGetter: (params) => {
      return params.data.blockExpiryPrint ? "true" : "false";
    },
  },
  isRecipe: {
    valueGetter: (params) => {
      return params.data.isRecipe ? "true" : "false";
    },
  },
};

export const productLogsColDefs = [
  {
    headerName: "Product Id",
    field: "medicineId",
    width: 120,
  },
  {
    headerName: "Updated Time",
    field: "created_at",
    width: 200,
    valueGetter: (params) => {
      return moment(`${params.data.created_at}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  {
    headerName: "Log Details",
    width: 500,
    field: "message",
    tooltipField: "message",
  },
];

export const initial_state_products = {
  type: PRODUCTS_TAB,
  label: "Products",
  allowMultipleTabs: false,
};

export const recipeTypeOptions = [
  "WD",
  "S",
  "SIN",
  "HIGH",
  "Z",
  "D",
  "MT",
  "TRI",
  "BIO",
];

export const modeCategoryOptions = [
  "V",
  "III",
  "IV",
  "I",
  "VII",
  "II",
  "IX",
  "VI",
  "VIII",
  "IX-S",
];
